if (!customElements.get('tabbed-products-section')) {
  class TabbedProductsSection extends HTMLElement {
    constructor() {
      super();
      this.swipers = {};
    }

    connectedCallback() {
      // Wait for Swiper to be available
      this.waitForSwiper().then(() => {
        this.initTabs();
        this.initSwipers();
        window.addEventListener('resize', () => this.handleResize());
      });
    }

    waitForSwiper() {
      return new Promise((resolve) => {
        if (typeof Swiper !== 'undefined') {
          resolve();
        } else {
          const checkSwiper = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              clearInterval(checkSwiper);
              resolve();
            }
          }, 100);
          // Timeout after 5 seconds
          setTimeout(() => {
            clearInterval(checkSwiper);
            resolve();
          }, 5000);
        }
      });
    }

    initTabs() {
      const tabButtons = this.querySelectorAll('.tabbedProductsSection_tab-btn');
      const tabPanels = this.querySelectorAll('.tabbedProductsSection_tab-panel');

      tabButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const tabId = button.dataset.tabId;

          // Remove active class from all buttons and panels
          tabButtons.forEach((btn) => btn.classList.remove('is-active'));
          tabPanels.forEach((panel) => panel.classList.remove('is-active'));

          // Add active class to clicked button and corresponding panel
          button.classList.add('is-active');
          const activePanel = this.querySelector(`#${tabId}`);
          if (activePanel) {
            activePanel.classList.add('is-active');

            // Update Swiper if it exists
            if (this.swipers[tabId]) {
              setTimeout(() => {
                this.swipers[tabId].update();
              }, 100);
            }
          }
        });
      });
    }

    initSwipers() {
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper library not loaded. Grid view will be used.');
        return;
      }

      const tabPanels = this.querySelectorAll('.tabbedProductsSection_tab-panel');

      tabPanels.forEach((panel) => {
        const swiperContainer = panel.querySelector('.tabbedProductsSection_swiper');
        if (swiperContainer && swiperContainer.querySelector('.swiper-wrapper')) {
          const tabId = panel.id;
          try {
            this.swipers[tabId] = new Swiper(swiperContainer, {
              slidesPerView: "auto",
              spaceBetween: 24,
              breakpoints: {
                480: {
                  slidesPerView: "auto",
                  spaceBetween: 24,
                  slidesPerGroup: 1,
                },
                768: {
                  slidesPerView: "auto",
                  spaceBetween: 24,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              },
            });
          } catch (error) {
            console.error('Error initializing Swiper:', error);
          }
        }
      });
    }

    handleResize() {
      if (Object.keys(this.swipers).length === 0) return;

      Object.values(this.swipers).forEach((swiper) => {
        if (swiper) {
          try {
            swiper.update();
          } catch (error) {
            console.error('Error updating Swiper:', error);
          }
        }
      });
    }
  }

  customElements.define('tabbed-products-section', TabbedProductsSection);
}
